export default __webpack_public_path__ + "static/media/caferogluyedi6.8fb38be4.jpg";